export default "__VITE_ASSET__C2jfRsI8__"